export * from './models/user.types';
export * from './models/informe.types';

export enum EstadoCita {
    BUSCAR_FECHA = 1,
    PENDIENTE_CONFIRMAR = 2,
    MANDADO_MENSAJE = 3,
    CONFIRMAR = 4,
    CANCELADO = 5
}

export const ESTADO_CITA_ETIQUETAS: Record<EstadoCita, string> = {
    [EstadoCita.BUSCAR_FECHA]: "Buscar Fecha en Calendario",
    [EstadoCita.PENDIENTE_CONFIRMAR]: "Pendiente de Confirmar",
    [EstadoCita.MANDADO_MENSAJE]: "Mandado Mensaje",
    [EstadoCita.CONFIRMAR]: "Confirmado",
    [EstadoCita.CANCELADO]: "Cancelado"
};

export interface Cita {
    id: number;
    informe_id: number;
    fecha: string;
    hora: string;
    telefono: string;
    titulo: string;
    estado: EstadoCita | number;
    google_calendar_event_id?: string;
    created_at: string;
    updated_at: string;
}

export interface CitaFormData {
    fecha: string;
    hora: string;
    telefono: string;
    titulo: string;
    estado?: EstadoCita | number;
}

export interface Videoperitacion {
    id: number;
    informe_id: number;
    zip_file_url: string;
    video_url?: string;
    audio_url?: string;
    imagenes_urls?: string[];
    geolocalizacion_url?: string;
    observaciones_url?: string;
    grabacion_perito_url?: string;
    grabacion_perito_transcripcion_url?: string;
    created_at: string;
    updated_at: string;
}

export interface InformePericialFeatureExtensions {
    fase?: 'encargo' | 'cita' | 'videoperitacion' | 'subidaArchivos' | 'grabacion' | 'previsualizacionContexto' | 'valoracion' | 'informe' | 'envio' | 'cerrado';
    informe_markdown?: string;
    titulo_cita?: string;
    fecha_cita?: string;
    hora_cita?: string;
    telefono_cita?: string;
    archivos_url?: string;
}

export interface InformesListProps {
    user: import('./models/user.types').User;
}
